import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText, Divider } from '@mui/material';

const SectorulSocialFilantropic: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Sectorul Social-Filantropic
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Departamente
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="Departamentul Social" 
                secondary="Responsabil pentru activitățile sociale"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Departamentul Filantropic" 
                secondary="Responsabil pentru activitățile de caritate"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Centrul de Ajutor Social" 
                secondary="Responsabil pentru ajutorul social"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Centrul de Caritate" 
                secondary="Responsabil pentru activitățile de caritate"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Centrul de Asistență" 
                secondary="Responsabil pentru asistența socială"
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SectorulSocialFilantropic;
